import { connectedApiService as api } from '../index'
import { handleActionError } from './helpers'
import { createOrEditItem, deleteItem } from './form'
import { showNotification } from './notifications'

export const editEventComments = (id, values) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      isEdit: true,
      endpoint: `events/${id}/comments`,
    })
  )
export const editEventCoordinators = (id, values) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      isEdit: true,
      endpoint: `events/${id}/coordinators`,
    })
  )
export const addShareEventUser = (id, eventId) => async dispatch =>
  await dispatch(
    createOrEditItem(
      {},
      { endpoint: `client-events/${eventId}/shareUser/${id}` }
    )
  )
export const removeShareEventUser = (id, eventId) => async dispatch =>
  await dispatch(
    createOrEditItem(
      {},
      { isEdit: true, endpoint: `client-events/${eventId}/shareUser/${id}` }
    )
  )
export const toggleUserStatus = (id, values) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      endpoint: 'eventBookings',
    })
  )
export const inviteEventUser = (id, values) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      endpoint: `client-events/${id}/invite`,
      successMessage: 'User was successfully invited',
    })
  )

//New flow
export const createEvent = values => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      endpoint: 'client-events',
    })
  )
export const createEventRate = (values, id) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      endpoint: `client-events/${id}/rates`,
      successMessage: 'Rate was successfully added',
    })
  )
export const createEventBooking = (values, id) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      endpoint: `client-events/${id}/bookings`,
      successMessage: 'Booking was successfully added',
    })
  )
export const addEventCoordinator = (values, id) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      endpoint: `client-events/${id}/coordinators`,
      successMessage: 'Coordinator was successfully added',
    })
  )
export const updateEventBooking = (values, id) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      isEdit: true,
      endpoint: `client-events/${id}/bookings`,
      successMessage: 'Booking was successfully updated',
    })
  )
export const updateEventCoordinator = (values, id) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      isEdit: true,
      endpoint: `client-events/${id}/coordinators`,
      successMessage: 'Coordinator was successfully updated',
    })
  )
export const updateEventSettings = (values, id) => async dispatch =>
  await dispatch(
    createOrEditItem(values, {
      isEdit: true,
      endpoint: `client-events/${id}/settings`,
      successMessage: 'Settings was successfully updated',
    })
  )

export const checkIfEventHasPartner = async (eventId, partnerServiceType) => {
  try {
    let url = `client-events/${eventId}/has-partners/${partnerServiceType}`
    const { data } = await api.get(url)
    return data.hasPartners
  } catch (error) {
    return handleActionError(error)
  }
}
